import { render } from "./ProgressBar.vue?vue&type=template&id=0b935efb"
import script from "./ProgressBar.vue?vue&type=script&lang=ts"
export * from "./ProgressBar.vue?vue&type=script&lang=ts"
script.render = render

export default script